import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { useAuth } from "@/context/AuthContext";
import { useCurrency } from "@/context/CurrencyContext";

export const StakeBox = ({ odds, onPlace, disabled, label = "Place bet", testid = "stake" }) => {
  const { user, setAuthOpen } = useAuth();
  const { currency, fmt, rate, fromZar } = useCurrency();
  const [stake, setStake] = useState("");
  const [busy, setBusy] = useState(false);
  const st = parseFloat(stake) || 0;
  const quick = rate > 5 ? [...new Set([5, 10, 50, 100].map((z) => Math.max(1, Math.round(fromZar(z)))))] : [1, 2, 5, 10];
  const go = async () => {
    if (!user) return setAuthOpen(true);
    setBusy(true);
    try {
      const ok = await onPlace(st);
      if (ok) setStake("");
    } finally {
      setBusy(false);
    }
  };
  return (
    <div className="space-y-2">
      <div className="flex items-center gap-2">
        <Input
          data-testid={`${testid}-input`}
          type="number"
          min="0"
          inputMode="decimal"
          placeholder={`Stake (${currency})`}
          value={stake}
          onChange={(e) => setStake(e.target.value)}
          className="h-10 bg-[#0E131F] font-odds"
        />
        <div className="shrink-0 text-right text-xs">
          <div className="text-slate-500">To win</div>
          <div data-testid={`${testid}-potential`} className="font-odds font-bold text-[#10B981]">{fmt(odds ? (st / rate) * odds : 0)}</div>
        </div>
      </div>
      <div className="grid grid-cols-4 gap-1">
        {quick.map((v) => (
          <button key={v} data-testid={`${testid}-quick-${v}`} onClick={() => setStake(String(v))} className="rounded bg-[#1A2234] py-1 text-xs font-semibold hover:bg-[#242F46]">
            {v}
          </button>
        ))}
      </div>
      <Button
        data-testid={`${testid}-submit`}
        disabled={busy || disabled || (user && st <= 0)}
        onClick={go}
        className="h-11 w-full bg-[#10B981] font-display text-base font-black uppercase text-[#0B0E14] hover:bg-[#059669]"
      >
        {!user ? "Log in to bet" : busy ? "Placing…" : label}
      </Button>
    </div>
  );
};
